import { render, staticRenderFns } from "./k-grid-display.vue?vue&type=template&id=a3611d7c&scoped=true"
import script from "./k-grid-display.vue?vue&type=script&lang=js"
export * from "./k-grid-display.vue?vue&type=script&lang=js"
import style0 from "./k-grid-display.vue?vue&type=style&index=0&id=a3611d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3611d7c",
  null
  
)

export default component.exports